module.exports = __webpack_public_path__ + "img/bg-casino-map-all.71a79395.jpg";